<ng-container *ngIf="rowData">
    <div class="brand-selection-table-container">
        <ag-grid-angular
            class="brand-selection-table-grid ag-theme-alpine"
            style="width: 100%; height: 100%;"
            [rowData]="rowData"
            [columnDefs]="colDefs"
            [modules]="modules"
            [theme]="theme"
            [gridOptions]="gridOptions"
            (gridReady)="onGridReady($event)"
            (bodyScroll)="updateFade()"
            (modelUpdated)="updateFade()">
        </ag-grid-angular>
    </div>
</ng-container>